import { graphBackFill, graphWallFill } from './';
export const graphOutlines = (theme, parameters) => {
  const common = {
    lineStyle: 'normal'
  };
  switch (theme.baseThemeName) {
    case 'dark':
      {
        return {
          ...common,
          lineColor: graphWallFill(theme, parameters).fillColor,
          lineThickness: 2
        };
      }
    case 'high-contrast':
      {
        return {
          ...common,
          lineColor: graphBackFill(theme, parameters).fillColor,
          lineThickness: 3
        };
      }
    default:
      {
        return {
          ...common,
          lineColor: graphWallFill(theme, parameters).fillColor,
          lineThickness: 1
        };
      }
  }
};
//# sourceMappingURL=graphOutlines.js.map